import { Enum_Userspermissionsuser_Ong } from '../../graphql/generated/graphql';

export const getNgoTitleAndSubtitle = (
  ong: Enum_Userspermissionsuser_Ong | null
) => {
  if (ong === Enum_Userspermissionsuser_Ong.SocieteProtectriceDesAnimaux) {
    return {
      title: "J'agis pour les animaux",
      subtitle: 'Société Protectrice des Animaux'
    };
  }
  if (ong === Enum_Userspermissionsuser_Ong.PlaneteUrgence) {
    return {
      title: "J'agis pour la planète",
      subtitle: 'Planète Urgence'
    };
  }
  if (ong === Enum_Userspermissionsuser_Ong.UnEnfantParLaMain) {
    return {
      title: "J'agis pour les enfants",
      subtitle: 'Un Enfant Par la Main'
    };
  }
  return {
    title: 'Découvrez nos ONG',
    subtitle: 'Choisissez. Contribuez. Visualisez.'
  };
};

export const getNgoImage = (ong: Enum_Userspermissionsuser_Ong) => {
  if (ong === Enum_Userspermissionsuser_Ong.PlaneteUrgence)
    return '/images/ong/PU-earth.webp';
  if (ong === Enum_Userspermissionsuser_Ong.SocieteProtectriceDesAnimaux)
    return '/images/ong/dog-spa.webp';
  if (ong === Enum_Userspermissionsuser_Ong.UnEnfantParLaMain)
    return '/images/ong/EPM-boy.webp';
  return '/images/ong/all-ong.webp';
};
